import { render, staticRenderFns } from "./AnalisiRischio.vue?vue&type=template&id=a9ce0a6a&"
import script from "./AnalisiRischio.vue?vue&type=script&lang=js&"
export * from "./AnalisiRischio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports